import React from "react";
import Row from "@amzn/meridian/row";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { signIn } from "src/store/userSlice";
import "./splash.scss";

/**
 * Splash screen shown to unauthenticated users instead of auto-starting the
 * login sequence. This page is SafetyGenie-owned (unlike the Amazon Federate
 * device-code page) and serves as the Add-to-Home-Screen / PWA entry point.
 * Tapping LOGIN kicks off the auth flow (Device Flow or Cognito, chosen by
 * device type inside signIn()).
 */
const SplashScreen: React.FC = () => {
  const dispatch = useAppDispatch();
  const signInLoading = useAppSelector((state) => state.user.signInLoading);
  const signInError = useAppSelector((state) => state.user.signInError);

  return (
    <div className="splash-screen">
      {/* Wordmark */}
      <div className="splash-top">
        <Row spacing="none" alignmentVertical="center">
          <span className="splash-wordmark">Safety</span>
          <span className="splash-wordmark splash-wordmark--accent">Genie</span>
        </Row>
      </div>

      {/* Worker illustration (workers + halos)*/}
      <div className="splash-illustration">
        <img
          className="splash-illustration__workers"
          src="/splash-workers.png"
          alt=""
          aria-hidden="true"
        />
      </div>

      {/* Login + WHS footer */}
      <div className="splash-bottom">
        <button
          className="splash-login-button"
          disabled={signInLoading === "pending"}
          onClick={() => dispatch(signIn())}
        >
          LOGIN
        </button>
        {signInError && (
          <span className="splash-login-error">
            Sign-in failed. Please try again.
          </span>
        )}
        <img
          className="splash-whs-logo"
          src="/WHS-Workplace_logo_white.png"
          alt="WHS Workplace Health & Safety"
        />
      </div>
    </div>
  );
};

export default SplashScreen;
